import script from "./AnnualFundraisingGoalsView.vue?vue&type=script&setup=true&lang=js"
export * from "./AnnualFundraisingGoalsView.vue?vue&type=script&setup=true&lang=js"

import "./AnnualFundraisingGoalsView.vue?vue&type=style&index=0&id=497ce0d0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-497ce0d0"]])

export default __exports__